<template>
	<v-modal>
		<v-date-picker
			is-inline
			:value="input.$attrs.value"
			:min-date="minDate"
			:max-date="maxDate"
			:mode="mode"
			@input="handleInput()"
			ref="activeDatePicker"/>
		<template v-slot:footer>
			<button class="button button--primary" @click.prevent="$vmodal.back()">Select</button>
		</template>
	</v-modal>
</template>
<script>

export default {
	props: {
		fieldLabel: {
			type: String,
			required: false,
			default() {
				return null;
			}
		},
		input: "",
		minDate: "",
		maxDate: "",
		mode: "",
	},

	methods: {
		handleInput(date) {
			this.input.changed(date);
		},
	},
};
</script>
